/* eslint-disable */

export const protobufPackage = "espressif";

export enum Status {
  Success = 0,
  InvalidSecScheme = 1,
  InvalidProto = 2,
  TooManySessions = 3,
  InvalidArgument = 4,
  InternalError = 5,
  CryptoError = 6,
  InvalidSession = 7,
  UNRECOGNIZED = -1,
}

export function statusFromJSON(object: any): Status {
  switch (object) {
    case 0:
    case "Success":
      return Status.Success;
    case 1:
    case "InvalidSecScheme":
      return Status.InvalidSecScheme;
    case 2:
    case "InvalidProto":
      return Status.InvalidProto;
    case 3:
    case "TooManySessions":
      return Status.TooManySessions;
    case 4:
    case "InvalidArgument":
      return Status.InvalidArgument;
    case 5:
    case "InternalError":
      return Status.InternalError;
    case 6:
    case "CryptoError":
      return Status.CryptoError;
    case 7:
    case "InvalidSession":
      return Status.InvalidSession;
    case -1:
    case "UNRECOGNIZED":
    default:
      return Status.UNRECOGNIZED;
  }
}

export function statusToJSON(object: Status): string {
  switch (object) {
    case Status.Success:
      return "Success";
    case Status.InvalidSecScheme:
      return "InvalidSecScheme";
    case Status.InvalidProto:
      return "InvalidProto";
    case Status.TooManySessions:
      return "TooManySessions";
    case Status.InvalidArgument:
      return "InvalidArgument";
    case Status.InternalError:
      return "InternalError";
    case Status.CryptoError:
      return "CryptoError";
    case Status.InvalidSession:
      return "InvalidSession";
    case Status.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
